import { React } from 'react';
import { Routes, Route } from 'react-router-dom';
import ShowStaff from './ShowStaff';
import CreateStaff from './CreateStaff';
import UpdateStaff from './UpdateStaff';

// This page need to install bootstrap axios and react-router-dom

function ManageStaff() {
    return (
        <>
            <Routes>
                <Route path='/' element={<ShowStaff />}></Route>
                <Route path='/create' element={<CreateStaff />}></Route>
                <Route path='/update/:subject/:id' element={<UpdateStaff />} />
            </Routes>
        </>
    )
}

export default ManageStaff
